module.exports = __webpack_public_path__ + "static/media/medicare-2027-thumb.5a593d19.jpg";